import React from "react";
import { AdvisorContainer } from "../../../containers";

const Advisor = (props) => {
  return <AdvisorContainer {...props} />;
};
export default Advisor;
